var _module = require('../module');

require('angular-input-masks');
require('../window-height');
require('../../services/lr-touch');
require('../../services/user');
require('../../services/verify-modal');
require('../../services/fullscreen-loading');
require('../../services/search-results-utils');
require('../../filters');

_module.requires.push('ui.utils.masks');

_module.component('accountSettings', {
    controllerAs: 'accountSettings',
    controller: [
        '$log',
        '$scope',
        '$timeout',
        '$state',
        '$stateParams',
        '$rootScope',
        '$user',
        'srUtils',
        '$window',

        function name($log, $scope, $timeout, $state, $stateParams, $rootScope, $user, srUtils, $window) {
            var _this = this;

            var initCurrentState = function () {
                _this.currState = $state.current || {};
            };

            var init = function () {
                _this.usr = $user;
                if(_this.usr.account_type == 'guest'){
                    $state.go('homepage');
                }

                _this.isMobile = srUtils.isMobile();
                initCurrentState();
            };

            init();

            // Public Functions

            _this.changeView = function (viewName) {
                if(viewName) {
                    if(['search', 'feed'].indexOf(viewName) < 0){
                        $state.go(['accountsettings', viewName].join('.'));
                    }else{
                        $state.go(viewName);
                    }
                }
            };

            /// EVENT HANDLERS

            angular.element($window).bind('resize', function() {
                _this.isMobile = srUtils.isMobile();
                $scope.$apply();
            });

            // manipulate layout based on rules in state config
            $rootScope.$on('$stateChangeSuccess',
                function (event, toState, toParams, fromState, fromParams){
                    var currState = $state.current || {};
                    if(currState && currState.data){
                        initCurrentState();
                    }
                }
            );

        }
    ],
    template: require('./index.html')
});
